import CustomAccording from "../../../customs/according"
import LinkSidebar from "../../../links/link_sidebar"

const SidebarKeuangan = () => {
    return (
        <>
            <LinkSidebar link="/dashboard" name="Dashboard" />
            <LinkSidebar link="/dashboard/crediture" name="Kreditur / Debitur" />
            <LinkSidebar link="/dashboard/financial" name="Keuangan" />
        </>
    )
}

export default SidebarKeuangan

